module.exports = __webpack_public_path__ + "img/img-2-5.5e6567df.webp";